<div class="employeePageContainer">
  <div class="stepsContainer">
    <dxo-steps [steps]="steps" (stepClick)="onStepClick($event)"/>
  </div>
  <div class="cardsContainer">
    <div id="employeeInformationCard">
      <dxo-card bodyHeader="{{ employeeCardTitle }}">
        <card-body>
          <form [formGroup]="addEmployeeForm" (ngSubmit)="submitForm()">
            <div class="data-container">
              <div class="text-input">
                <div class="row-input-odd">
                  <dxo-text-input
                    [label]="employeeData.firstName.label"
                    [maxlength]="80"
                    formControlName="firstName"
                    [errorControl]="formErrors.firstName"
                  ></dxo-text-input>
                  <dxo-text-input
                    [label]="employeeData.middleName.label"
                    [maxlength]="80"
                    formControlName="middleName"
                    [hint]="'(optional)'"
                    [hideHintIcon]='"always"'
                  ></dxo-text-input>
                </div>
                <div class="row-input-odd">
                  <dxo-text-input
                    [label]="employeeData.lastName.label"
                    [maxlength]="80"
                    formControlName="lastName"
                    [errorControl]="formErrors.lastName"
                  ></dxo-text-input>
                  <dxo-text-input
                    [label]="employeeData.ssn.label"
                    [maxlength]="11"
                    formControlName="ssn"
                    (input)="onSSNInputChange($event)"
                    [placeholder]="employeeData.ssn.placeholder"
                    [errorControl]="formErrors.ssn"
                  ></dxo-text-input>
                </div>
                <div class="row-input-even">
                  <dxo-text-input
                    [label]="employeeData.birthDate.label"
                    [maxlength]="80"
                    type="date"
                    [hint]="'(MM/DD/YYYY)'"
                    [hideHintIcon]='"always"'
                    formControlName="birthDate"
                    [errorControl]="formErrors.birthDate"
                  ></dxo-text-input>

                  <dxo-dropdown
                    data-e2e="GenderDropdown"
                    label="Gender"
                    class="GenderDropdown"
                    formControlName="gender"
                    [errorControl]="formErrors.gender"
                    [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
                    [optionsObjects]="genderListOptions"
                  >
                  </dxo-dropdown>
                </div>
                <div class="row-input-even">
                  <dxo-text-input
                    [label]="employeeData.hireDate.label"
                    [maxlength]="80"
                    type="date"
                    [hint]="'(MM/DD/YYYY)'"
                    formControlName="hireDate"
                    [hideHintIcon]='"always"'
                    [errorControl]="formErrors.hireDate"
                  ></dxo-text-input>
                  <dxo-dropdown
                    data-e2e="SmokerStatusDropdown"
                    label="Smoker Status"
                    formControlName="smokerStatus"
                    class="SmokerStatusDropdown"
                    [hideHintIcon]='"always"'
                    [hint] = "'(optional)'"
                    [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
                    [optionsObjects]="smokerStatusOptions"
                  >
                  </dxo-dropdown>
                </div>
                <div class="row-input-odd">
                  <dxo-text-input
                    [label]="employeeData.occupation.label"
                    [maxlength]="80"
                    formControlName="occupation"
                    [hint]="'(optional)'"
                    [hideHintIcon]='"always"'
                  ></dxo-text-input>
                  <dxo-text-input
                    [label]="employeeData.annualSalary.label"
                    [maxlength]="80"
                    formControlName="annualSalary"
                    [errorControl]="formErrors.annualSalary"
                  ></dxo-text-input>
                </div>
                <div class="fullText">
                  <dxo-dropdown
                    data-e2e="BillDiviDropdown"
                    label="Bill Division"
                    class="BillDivisionDropdown"
                    formControlName="billDivision"
                    [dxoDataset]="[{ selector: '.dxo-input, ul', data: { pii: '' } }]"
                    [optionsObjects]="billDivisionOptions"
                  >
                  </dxo-dropdown>
                </div>
                <div class="row-input">
                  <dxo-button
                    [primary]="true"
                    text="{{ secondaryButtonText }}"
                    data-category="request"
                    data-action="Close Modal"
                    (handleClick)="submitForm()"
                  >
                  </dxo-button>
                </div>
              </div>
            </div>
          </form>
        </card-body>
      </dxo-card>
    </div>
  </div>
</div>
